<template>
    <Button label="Atualizar data vencimento" class="ml-3" @click="ShowAtualizarVencimento()" icon="pi pi-pencil" v-if="mostrarBtnAtualizarDataVencimento" />
    <Dialog v-model:visible="showAtualizarVencimento" :modal="true" :style="{ width: '20vw' }" header="Atualizar Vencimento">
        <div class="col-lg-12">
            <div class="flex flex-column">
                <label class="required mb-3">Nova data vencimento</label>
                <Calendar
                    v-model="novaDataVencimento"
                    :monthNavigator="true"
                    :yearNavigator="true"
                    :minDate="dataMinima"
                    :maxDate="dataMaxima"
                    :manualInput="false"
                />
            </div>
        </div>
        <template #footer>
            <Button class="p-button-text" icon="pi pi-times" label="Fechar" @click="closeConfirmarAtualizacaoVencimento(false)" />
            <Button
                autofocus
                class="p-button-text"
                icon="pi pi-check"
                label="Salvar"
                @click="closeConfirmarAtualizacaoVencimento(true)"
                :disabled="!isNovaDataDeVencimentoValida"
            />
        </template>
    </Dialog>
</template>

<script>
import services from './service';

export default {
    props: {
        dataMinima: null,
        dataMaxima: null,
    },
    data() {
        return {
            showAtualizarVencimento: false,
            novaDataVencimento: null,
        };
    },
    emits: ['obterCheckout'],

    methods: {
        ShowAtualizarVencimento() {
            this.showAtualizarVencimento = true;
        },
        closeConfirmarAtualizacaoVencimento(confirmarAtualizacaoVencimento) {
            this.showAtualizarVencimento = false;
            if (confirmarAtualizacaoVencimento) {
                this.$store.dispatch('addRequest');
                services
                    .atualizarDataVencimento(this.$route.params.id, this.novaDataVencimento)
                    .then((response) => {
                        this.$toast.add({
                            severity: response.success ? 'success' : 'error',
                            summary: response.success ? 'Sucesso' : 'Error',
                            detail: response.success ? 'Data de vencimento atualizada com sucesso' : 'Erro ao atualizar data de vencimento',
                            life: 3000,
                        });
                        this.novaDataVencimento = null;
                        this.$emit('obterCheckout');
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Erro',
                            detail: 'Erro ao buscar detalhes do pedido',
                            life: 3000,
                        });
                        this.error = error;
                    })
                    .finally(() => {
                        this.$store.dispatch('removeRequest');
                    });
            }
        },
    },

    computed: {
        isNovaDataDeVencimentoValida() {
            return this.novaDataVencimento != null;
        },
        mostrarBtnAtualizarDataVencimento() {
            return this.$temAcessoView('CHECKOUTS-PAGAMENTOS-09');
        },
    },
};
</script>
